import { useState, useEffect } from 'react';
import styles from './DeadlineCountdown.module.css';

interface DeadlineCountdownProps {
    deadline: string | null;
}

function getTimeRemaining(deadline: string) {
    const diff = new Date(deadline).getTime() - Date.now();
    if (diff <= 0) return null;

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    if (days > 0) return `${days}d ${hours}h`;
    if (hours > 0) return `${hours}h ${minutes}m`;
    return `${minutes}m`;
}

export function DeadlineCountdown({ deadline }: DeadlineCountdownProps) {
    const [remaining, setRemaining] = useState<string | null>(null);

    useEffect(() => {
        if (!deadline) return;
        const update = () => setRemaining(getTimeRemaining(deadline));
        update();
        const interval = setInterval(update, 60000);
        return () => clearInterval(interval);
    }, [deadline]);

    if (!deadline) return <span className={styles.noDeadline}>Sin fecha límite</span>;
    if (remaining === null) return <span className={styles.expired}>Expirado</span>;

    const isUrgent = new Date(deadline).getTime() - Date.now() < 24 * 60 * 60 * 1000;

    return (
        <span className={`${styles.countdown} ${isUrgent ? styles.urgent : ''}`}>
            {remaining}
        </span>
    );
}
